import request from '@/utils/request'

export const getPayMode = async(): Promise<any> => {
  return request({
    url: '/pay_mode',
    method: 'get'
  })
}

export const setPayMode = async(data: any): Promise<any> => {
  return request({
    url: '/pay_mode',
    method: 'post',
    data
  })
}

export const getTodayPayMode = async(): Promise<any> => {
  return request({
    url: '/pay_mode/today',
    method: 'get'
  })
}
